// import Vue from 'vue'
import { createStorage } from 'vuex-localstorage'
import { firebase, firestore } from '@/api/firebase'
// import UserService from '@/services/user.js'

const USER_KEY = 'user'
let storeState = {}
let persist = null
if (window.localStorage) {
  persist = createStorage({
    namespace: USER_KEY,
    initialState: {
      user: null,
      firebase: null
    }
  })
  storeState = persist.get()
}

// initial state
const state = Object.assign({}, storeState)
// getters
const getters = {
  getUser: state => state.user,
  getFullName: state => {
    return ''
  },
  getPhotoUrl: state => {
    return (state.photo && state.photo.url) ? state.photo.url : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
  },
  isAuthenticated: state => {
    if (state.user) {
      return true
    }
    return false
  }
}

const mutations = {
  signout (state) {
    const user = {
      user: null,
      firebase: null
    }
    Object.assign(state, {}, user)
    if (persist) {
      persist.set(user)
    }
  },
  setUser (state, result) {
    if (persist) {
      persist.set(result)
    }
    Object.assign(state, result)
  }
}

const actions = {
  async signin ({ commit }, credentials) {
    let user = null
    const firebaseUser = await firebase.auth().signInWithEmailAndPassword(credentials.email, credentials.password)
    if (firebaseUser && firebaseUser.uid) {
      const userDoc = await firestore.collection('users').doc(firebaseUser.uid).get()
      if (userDoc.exists) {
        user = userDoc.data()
      }
    }
    const data = {
      firebase: {
        uid: firebaseUser.uid,
        email: firebaseUser.email,
        refreshToken: firebaseUser.refreshToken,
        emailVerified: firebaseUser.emailVerified,
        displayName: firebaseUser.displayName
      },
      user
    }
    commit('setUser', data)
    return data
  },
  signout ({ commit }) {
    commit('signout')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/stores/auth.js